export const Access = Object.freeze({
	Administrator: 0,
	Client: 1,
})

export function isClient(access){
	return access == Access.Client;
}

export function isAdmin(access){
	return access == Access.Administrator;
}